"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.strategyMatrixQueryStateDefaults = void 0;
const strategy_matrix_query_params_models_1 = require("./strategy-matrix-query-params.models");
const store_1 = require("../../store");
exports.strategyMatrixQueryStateDefaults = {
    [strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.ExtendedFilter]: store_1.defaultStrategyMatrixState.extendedFilter,
    [strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.SelectedAttributes]: store_1.defaultStrategyMatrixState.selectedAttributes,
    [strategy_matrix_query_params_models_1.StrategyMatrixViewQueryStateField.SelectedDisplayTable]: store_1.defaultStrategyMatrixState.selectedDisplayTable,
};
